module.exports = __webpack_public_path__ + "static/media/biaoge_02.fbb46432.png";